import {
  useCreateProvider,
  useDeleteProvider,
  useListProviders,
  useProviderPublishMessage,
  useProviders,
  useScheduleMeals,
  useUpdateProvider,
} from '../utils/api.hook';
import { ProvidersComponent } from './providers.component';
import { usePagination } from '../shared/usePagination';
import { FilterValue } from 'antd/es/table/interface';
import { QP, useQueryParams } from '../shared/useQueryParams';
import dayjs from 'dayjs';
import { map, pickBy } from 'lodash';

const providersQuerySchema = {
  keyword: QP.string('keyword'),
  status: QP.stringArray('status'),
  needPosSticker: QP.boolean('needPosSticker'),
  types: QP.stringArray('types'),
};

const toStringArray = (
  value: FilterValue | null | undefined
): string[] | undefined => (value && value.length ? value.map(String) : undefined);

export function ProvidersContainer() {
  const { values, setValues } = useQueryParams(providersQuerySchema);
  const { keyword, status, needPosSticker, types } = values;
  const setKeyword = (value: string) => setValues({ keyword: value });
  const setFilters = (next: Record<string, FilterValue | null>) =>
    setValues({
      status: toStringArray(next.status),
      types: toStringArray(next.types),
      needPosSticker:
        Array.isArray(next.needPosSticker) &&
        typeof next.needPosSticker[0] === 'boolean'
          ? next.needPosSticker[0]
          : undefined,
    });
  const {
    isLoading: isProviderListLoading,
    data: { providers: providersList } = {},
  } = useListProviders();

  const {
    data: { providers, total } = {},
    isLoading,
    isFetching,
  } = useProviders({
    keyword,
  });
  const { mutateAsync: createProvider, isLoading: isCreatingProvider } =
    useCreateProvider();
  const { mutateAsync: deleteProvider, isLoading: isDeletingProvider } =
    useDeleteProvider();
  const { mutateAsync: updateProvider, isLoading: isUpdatingProvider } =
    useUpdateProvider();
  const { data: { deliveryMeals: todayDeliveryMeals = [] } = {} } =
    useScheduleMeals({
      startTime: dayjs().startOf('day').valueOf(),
      endTime: dayjs().endOf('day').valueOf(),
    });
  const { mutateAsync: sendProviderPublishMessage } =
    useProviderPublishMessage();
  const pagination = usePagination({
    defaultPageSize: 15,
    syncUrl: true,
  });

  return (
    <ProvidersComponent
      activatedProviderIds={map(
        pickBy(providersList, ['status', 'ACTIVE']),
        'id'
      )}
      createProvider={createProvider}
      data={providers}
      deleteProvider={deleteProvider}
      setKeyword={setKeyword}
      keyword={keyword}
      filters={{ status, needPosSticker, types }}
      updateProvider={updateProvider}
      todayDeliveryMeals={todayDeliveryMeals}
      sendProviderPublishMessage={sendProviderPublishMessage}
      setFilters={setFilters}
      isLoading={
        isLoading ||
        isFetching ||
        isCreatingProvider ||
        isDeletingProvider ||
        isUpdatingProvider ||
        isProviderListLoading
      }
      pagination={{
        ...pagination,
        total,
      }}
    />
  );
}
